import i18n from '@/utils/i18n'
// Copy of field type codes from /backend/src/Entity/BookingInputField.php

export const fieldTypes = {
  NUMERIC: 10,
  TEXT: 20,
  EMAIL: 21,
  PHONE: 22,
  DROP_DOWN_MENU: 30,
  BOOLEAN: 40,
  PARAGRAPH: 50
}

export function getFieldTypeTranslation (type) {
  if (typeof type === 'object') type = type[0]

  let ret = 'undefined'

  for (let [key, fieldType] of Object.entries(fieldTypes)) {
    if (fieldType == type) {
      ret = i18n.t('bookinginputfield.type.' + fieldType)
    }
  }

  return ret
}
